// src/components/Explore/ExploreView.jsx
// Container for the Explore mode - Map + Filters + Club Tiles

import React from 'react';
import Map from '../Map';
import FilterBar from './FilterBar';
import ClubProgramTileList from './ClubProgramTileList';
import { FaSyncAlt } from 'react-icons/fa';
import styles from './ExploreView.module.css';

const ExploreView = ({
  userLocation,
  clubs,
  capacityMap,
  filters,
  updateFilter,
  updateFilters,
  clearFilter,
  resetFilters,
  activeFiltersCount,
  totalStats,
  isLoading,
  rangeInMiles,
  onRangeChange,
  onRefresh,
  userClubs,
  onClubMarkerClick,
  onLocationChange,
  // Mode toggle props (handled at LandingPage level now)
  activeMode,
  onModeChange
}) => {
  return (
    <div className={styles.exploreView}>
      {/* Map Section */}
      <section className={styles.mapSection}>
        {/* Refresh Button - Overlaid on Map */}
        <div className={styles.mapToggleOverlay}>
          <div className={styles.toggleRow}>
            <button
              type="button"
              className={`${styles.refreshButton} ${isLoading ? styles.loading : ''}`}
              onClick={onRefresh}
              disabled={isLoading}
              title="Refresh results"
            >
              <FaSyncAlt className={styles.refreshIcon} />
            </button>
          </div>
        </div>

        {userLocation ? (
          <Map
            clubs={clubs}
            userLocation={userLocation}
            onClubMarkerClick={onClubMarkerClick}
            rangeInMiles={rangeInMiles}
            onRangeChange={onRangeChange}
            showRangeControl={true}
            onLocationChange={onLocationChange}
          />
        ) : (
          <div className={styles.mapLoader}>
            <div className={styles.spinner}></div>
            <p>Loading your location...</p>
          </div>
        )}
      </section>

      {/* Filter Bar */}
      <section className={styles.filterSection}>
        <FilterBar
          filters={filters}
          updateFilter={updateFilter}
          updateFilters={updateFilters}
          clearFilter={clearFilter}
          resetFilters={resetFilters}
          activeFiltersCount={activeFiltersCount}
          totalStats={totalStats}
          isLoading={isLoading}
          onRefresh={onRefresh}
        />
      </section>

      {/* Results Section */}
      <section className={styles.resultsSection}>
        <ClubProgramTileList
          clubs={clubs}
          capacityMap={capacityMap}
          userClubs={userClubs}
          isLoading={isLoading}
        />
      </section>
    </div>
  );
};

export default ExploreView;

